import React from "react";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import {
    AccordionSingleProps,
    Content,
    Item,
    Root,
    Trigger,
} from "@singlestore/fusion/components/accordion/primitive";
import { Paragraph } from "@singlestore/fusion/components/typography";
import { cx } from "class-variance-authority";

import { FaIcon } from "components/FaIcon/FaIcon";

import "./Accordion.scss";

export type AccordionTriggerProps = React.ComponentProps<typeof Trigger>;

export const AccordionTrigger = React.forwardRef<
    React.ElementRef<typeof Trigger>,
    React.PropsWithChildren<AccordionTriggerProps>
>(({ children, className, ...props }, forwardedRef) => (
    <Trigger
        {...props}
        ref={forwardedRef}
        className={cx("accordion-trigger", className)}
    >
        <Paragraph variant="body-3" className="title">
            {children}
        </Paragraph>
        <FaIcon icon={faChevronDown} className="accordion-icon" />
    </Trigger>
));

export type AccordionContentProps = React.ComponentProps<typeof Content>;

export const AccordionContent = React.forwardRef<
    React.ElementRef<typeof Content>,
    React.PropsWithChildren<AccordionContentProps>
>(({ children, className, ...props }, forwardedRef) => (
    <Content
        {...props}
        ref={forwardedRef}
        className={cx("accordion-content", className)}
    >
        <div>{children}</div>
    </Content>
));

export type AccordionItemProps = React.ComponentProps<typeof Item>;

export const AccordionItem = React.forwardRef<
    React.ElementRef<typeof Item>,
    React.PropsWithChildren<AccordionItemProps>
>(({ children, className, ...props }, forwardedRef) => (
    <Item
        {...props}
        ref={forwardedRef}
        className={cx("accordion-item", className)}
    >
        {children}
    </Item>
));

export const AccordionRoot = React.forwardRef<
    React.ElementRef<typeof Root>,
    React.PropsWithChildren<AccordionSingleProps>
>(({ children, className, ...props }, forwardedRef) => (
    <Root {...props} ref={forwardedRef} className={cx("accordion", className)}>
        {children}
    </Root>
));
